import { render, staticRenderFns } from "./docking.vue?vue&type=template&id=588c6b67&scoped=true"
import script from "./docking.vue?vue&type=script&lang=js"
export * from "./docking.vue?vue&type=script&lang=js"
import style0 from "./docking.vue?vue&type=style&index=0&id=588c6b67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c6b67",
  null
  
)

export default component.exports